/**
 * 品牌活動 API client(公開 endpoint,不必 JWT — 跟溯源同款)
 *
 * GET /api/brand-events/{slug} → 完整頁內容(後台「品牌活動」自建)
 */
import { api } from "./client";

export interface BrandEventSection {
  icon?: string;
  title: string;
  body: string;
}

export interface BrandEventRelatedProduct {
  name: string;
  spec: string;
  note?: string;
  product_id?: string;
}

export interface BrandEventData {
  slug: string;
  title_zh: string;
  title_en: string;
  date: string;
  venue: string;
  card_image: string;
  card_lines: string[];
  has_detail: boolean;
  active: boolean;
  sort_order: number;
  eyebrow: string;
  hero_image: string;
  hero_aspect: "4/3" | "3/4";
  lead: string;
  intro: string[];
  sections: BrandEventSection[];
  closing: string[];
  tags: string[];
  gallery: string[];
  related_product: BrandEventRelatedProduct;
}

export async function fetchBrandEvent(slug: string): Promise<BrandEventData | null> {
  try {
    const { data } = await api.get(`/api/brand-events/${encodeURIComponent(slug)}`);
    return data?.found ? (data.event as BrandEventData) : null;
  } catch {
    return null; // 404 / 網路失敗 → caller fallback hardcode
  }
}
